/**
 * How a vector layer looks before anyone styles it: a plain circle, line or fill
 * in the org's primary colour. CM tables without a style and external data layers
 * without an icon or style both render this way, so an unstyled layer looks the
 * same whichever kind it is.
 */

/** Fallback colour when no theme primary is available. */
export const DEFAULT_FEATURE_COLOR = "#3b82f6";

export const defaultPointPaint = (color: string) => ({
  "circle-radius": 7,
  "circle-color": color,
  "circle-stroke-width": 1.5,
  "circle-stroke-color": "#ffffff"
});

export const defaultLinePaint = (color: string) => ({ "line-width": 3, "line-color": color });

export const defaultFillPaint = (color: string) => ({ "fill-opacity": 0.4, "fill-color": color, "fill-outline-color": color });
